<div class="post-login-2">
  <div class="post-login-2-col-1 h-100">
    <left-panel activeTab="5"></left-panel>
  </div>
  <div class="post-login-2-col-2 has-banner">
  </div>
  <div class="post-login-2-col-3  bg-base-100 p-mobile-15 h-100 pt-70-pb-70-pr-40">
    <div class="onboarding-canvas">
      <div class="font-400 font-size-20px line-h-25 mt-ipad-15">
        {{ "LetMobileNumber" | translate }}
      </div>
      <div class="form-group mt-50">
        <label class="no-mark">
          {{ "MobileNumber" | translate }}
        </label>
        <grid-row>
          <grid-col col="2">
            <input type="text" placeholder="" [(ngModel)]="this.MobileCode">
          </grid-col>
          <!-- <grid-col col="10"> 
            <input type="text" placeholder="551815104" (change)="Change($event)" (keydown)="this.onKeyDownSaveChanges($event)" mask="99999999"
              [(ngModel)]="this.MobileNo">
          </grid-col> -->
          <grid-col col="10">
            <input type="text" placeholder="551815104" (ngModelChange)="onMobileChange($event)"
              (keydown)="onKeyDownSaveChanges($event)" mask="99999999" [(ngModel)]="MobileNo" />

            <!-- Error message for same number -->
            <div *ngIf="isSameNumber" style="color: red; font-size: 13px; margin-top: 4px;">
              You have entered the same number. Please enter a new mobile number.
            </div>
          </grid-col>
          <!-- <grid-col col="10">
  <input
    type="text"
    placeholder="551815104"
    (ngModelChange)="onMobileChange($event)"
    (keydown)="onKeyDownSaveChanges($event)"
    mask="99999999"
    [(ngModel)]="MobileNo" />
</grid-col> -->
        </grid-row>


      </div>
      <grid-row class="justify-content-between justify-content-between align-content-end mt-50 h-100">
        <grid-col col="auto">
          <button class="btn-back" (click)="back()">
            <i class="icon-back"></i>
          </button>
        </grid-col>
        <grid-col col="9">
          <!-- <button class="btn-dft" (click)="updateMobile(2)" [disabled]="this.EnableForChange">
            {{ "SaveChanges" | translate }}
          </button> -->
          <button class="btn-dft" (click)="updateMobile(2)" [disabled]="EnableForChange">
            {{ "SaveChanges" | translate }}
          </button>

          <!-- <button class="btn-dft" (click)="verifyMobileOtp()">
            {{ "SaveChanges" | translate }}
          </button> -->
        </grid-col>
      </grid-row>
    </div>
  </div>
</div>


<!-- <modal modalID="2" [events]="modalObservable.asObservable()" [backdropDismiss]="true" modalDoneButtonText="Verify"
  (doneButton)="verifyViaEmailOtp(3)">
  <div class="text-align-center">
    <ng-icon iconClass="icon-otp-pin br-8 bg-nuetral-primary" width="80" height="80"></ng-icon>
    <div class="mt-30">
      <span class="color-base-700 font-size-20px font-400 line-h-25">
        {{ "Enter4digit" | translate }}
      </span>
      <span class="color-primary font-size-20px font-400 line-h-25">
        {{this.CommonService.maskEmail(this.Email)}}

      </span>
    </div>
    <div class="mt-50 form-group">
      <ng-otp-input (onInputChange)="onOtpChange($event)" (keydown)="onKeyDownEmail($event)" allowNumbersOnly='true'
        [config]="{length:4,allowNumbersOnly:true}"></ng-otp-input>
    </div>
    <grid-row class="justify-content-between align-item-center mt-50">
      <grid-col col="auto">
        <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15">
          <div class="font-600 font-size-12px color-primary letter-spacing-1">
            {{ "Resend" | translate }}
            <span *ngIf="true" class="font-600 font-size-12px color-primary letter-spacing-1">{{timerexpire}}</span>
          </div>
        </div>
      </grid-col>
  
    </grid-row>
  </div>

</modal> -->



<!-- <modal modalID="3" [events]="modalObservable.asObservable()" [backdropDismiss]="true" modalDoneButtonText="Verify"
  (doneButton)="verifyViaMobileOtp()">
  <div class="text-align-center">
    <ng-icon iconClass="icon-otp-pin br-8 bg-nuetral-primary" width="80" height="80"></ng-icon>
    <div class="mt-30">
      <span class="color-base-700 font-size-20px font-400 line-h-25">
        {{ "Enter4digit" | translate }}
      </span>
      <span class="color-primary font-size-20px font-400 line-h-25">
        {{this.CommonService.maskMobileNumber(this?.auth?.detailuser?.mobileNumber)}}
      </span>
    </div>
    <div class="mt-50 form-group">
      <ng-otp-input (onInputChange)="onOtpChange($event)" (keydown)="onKeyDownMobile($event)" allowNumbersOnly='true'
        [config]="{length:4,allowNumbersOnly:true}"></ng-otp-input>
    </div>
    <grid-row class="justify-content-between align-item-center mt-50">
      <grid-col col="auto">
        <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15">
          <div class="font-600 font-size-12px color-primary letter-spacing-1">
            {{ "Resend" | translate }}
            <span *ngIf="true" class="font-600 font-size-12px color-primary letter-spacing-1">{{timerexpire}}</span>
          </div>
        </div>
      </grid-col>
      <grid-col col="auto" mobile="12" class="mt-mobile-15">
        <div class="link font-600 font-size-12px color-primary text-align-left">
          {{ "ChangeMobileNumber" | translate }}
        </div>
      </grid-col>
    </grid-row>
  </div>

</modal> -->